module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Karen-Pisciotta-5985a32541103f824538d204b7cc66be.png";